/**
 * Khmer (ភាសាខ្មែរ) dictionary. Must mirror every key of src/i18n/en.ts —
 * typed as `Dictionary` so missing keys fail the build.
 */
import type { Dictionary } from './en';

const km: Dictionary = {
  loading: 'កំពុងផ្ទុក…',
  nav: {
    aboutUs: 'អំពីយើង',
    solutions: 'ដំណោះស្រាយ',
    products: 'ផលិតផល',
    features: 'មុខងារពិសេស',
    portfolios: 'សមិទ្ធផល',
    contact: 'ទំនាក់ទំនង',
    blogs: 'ប្លុក',
    docs: 'ឯកសារណែនាំ',
  },
  footer: {
    tagline:
      'AKAS ផ្តល់ដំណោះស្រាយ Cloud ERP សម្រាប់អាជីវកម្ម ដើម្បីសម្រួលប្រតិបត្តិការ និងបង្កើនផលិតភាព។',
    modules: 'ម៉ូឌុល',
    moreModules: 'ម៉ូឌុលបន្ថែម',
    company: 'ក្រុមហ៊ុន',
    contact: 'ទំនាក់ទំនង',
    aboutUs: 'អំពីយើង',
    solutions: 'ដំណោះស្រាយ',
    liveDemos: 'សាកល្បងប្រើផ្ទាល់',
    portfolios: 'សមិទ្ធផល',
    blogs: 'ប្លុក',
    location: 'រាជធានីភ្នំពេញ ព្រះរាជាណាចក្រកម្ពុជា',
    allRightsReserved: 'រក្សាសិទ្ធិគ្រប់យ៉ាង។',
    builtBy: 'បង្កើតនៅភ្នំពេញ កម្ពុជា · Cloud ERP សម្រាប់អាជីវកម្មដែលកំពុងរីកចម្រើន',
  },
  hero: {
    badge: 'Cloud ERP សម្រាប់អាជីវកម្មដែលកំពុងរីកចម្រើន',
    title: 'គ្រប់គ្រងអាជីវកម្មទាំងមូល',
    titleAccent: 'លើប្រព័ន្ធតែមួយ',
    description:
      'បុគ្គលិក ការលក់ ស្តុក និងគណនេយ្យ — តភ្ជាប់គ្នាក្នុងប្រព័ន្ធតែមួយ ជាភាសាខ្មែរ និងអង់គ្លេស។',
    primaryCta: 'សាកល្បង Demo ផ្ទាល់',
    secondaryCta: 'មើលមុខងារទាំងអស់',
  },
  process: {
    kicker: 'ដំណើរការតភ្ជាប់គ្នា',
    title: 'បញ្ចូលតែម្តង គ្រប់គ្នាឃើញ',
    lead:
      'ផ្នែកលក់ ឃ្លាំងធនធានមនុស្ស និងហិរញ្ញវត្ថុ ធ្វើការលើទិន្នន័យរួមតែមួយ — មិនចាំបាច់វាយឡើងវិញ ក៏មិនចាំបាច់ប្រើ Excel ដាច់ដោយឡែកទេ។ សម្រង់តម្លៃដែលឈ្នះ ការទទួលស្តុក និងស្លឹកប្រាក់ខែ ចូលក្នុងសៀវភៅគណនេយ្យតែមួយ ដូច្នេះលេខរបស់អ្នកត្រូវគ្នាជានិច្ច។',
    openModule: 'ព័ត៌មានលម្អិត',
    guide: 'មគ្គុទ្ទេសក៍',
    items: [
      {
        title: 'ពីការជ្រើសរើសបុគ្គលិកដល់ចូលនិវត្តន៍',
        path: 'Requisition → Hire → Attend / leave → Pay → Review → Exit',
        description:
          'ការជ្រើសរើសបុគ្គលិក ព័ត៌មានបុគ្គលិក វត្តមាន ការឈប់សម្រាក ការគណនាប្រាក់ខែ (រួមទាំងពន្ធ NSSF និងអាយុការ) ការវាយតម្លៃការងារ បណ្តុះបណ្តាល និងសេវាកម្មបុគ្គលិកដោយខ្លួនឯង — ទាំងអស់ស្ថិតលើកំណត់ត្រាបុគ្គលិកតែមួយ។',
      },
      {
        title: 'ពីអតិថិជនសក្តានុពលដល់ចំណូល',
        path: 'Lead → Customer → Opportunity → Quote → Order → Invoice → Receipt',
        description:
          'សម្រង់តម្លៃក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន បម្លែងជាបញ្ជាលក់។ វិក្កយបត្រ KHQR ប្រាក់កក់ និងគណនីត្រូវទទួល (AR) ស្ថិតក្នុងការគ្រប់គ្រងចំណូល។ ការលក់តាមបញ្ជរ និងហាងអនឡាញលក់ទំនិញដូចគ្នា។',
      },
      {
        title: 'ពីការទិញដល់ការទូទាត់',
        path: 'Vendor → Purchase order → Receive → Bill → Payment',
        description:
          'ការបញ្ជាទិញ និងការទទួលទំនិញក្នុងស្តុក ប្រើអ្នកផ្គត់ផ្គង់ដូចគ្នាជាមួយផ្នែកចំណាយ។ វិក្កយបត្រទិញ ប្រាក់កក់ និងគណនីត្រូវបង់ (AP) ចុះបញ្ជីដោយស្វ័យប្រវត្តិ នៅពេលការភ្ជាប់គណនេយ្យត្រូវបានកំណត់រួច។',
      },
    ],
  },
  modules: {
    kicker: 'ម៉ូឌុល ERP',
    title: 'អ្វីដែលអ្នកទទួលបានពី AKAS',
    lead:
      'ចាប់ផ្តើមពីអ្វីដែលអ្នកត្រូវការថ្ងៃនេះ — បុគ្គលិក ការលក់ ការទិញ ស្តុក គណនេយ្យ ការលក់តាមបញ្ជរ ឬហាងអនឡាញ។ អ្វីៗទាំងអស់ប្រើអតិថិជន ទំនិញ ទីតាំង និងការអនុម័តរួមគ្នា ដូច្នេះការបន្ថែមម៉ូឌុលនៅពេលក្រោយគ្រាន់តែដំណើរការទៅ។',
    moduleDetails: 'ព័ត៌មានលម្អិត',
    userGuide: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់',
    browse: {
      kicker: 'មុខងារទាំងអស់',
      title: 'មើលរបៀបដែលម៉ូឌុលទាំងអស់តភ្ជាប់គ្នា',
      description:
        'ការគណនាប្រាក់ខែ ការលក់ ស្តុក និងគណនេយ្យ — ជាមួយព័ត៌មានលម្អិតនៅខាងក្រោយនីមួយៗ និងមគ្គុទ្ទេសក៍សម្រាប់គ្រប់ផ្នែក។',
      link: 'ស្វែងរកមុខងារ →',
    },
  },
  platform: {
    kicker: 'ងាយស្រួលប្រើ ពិបាកប្រើខុស',
    title: 'កំណត់ច្បាប់របស់អ្នកនៅកន្លែងតែមួយ — ម៉ូឌុលទាំងអស់ធ្វើតាម',
    description:
      'រចនាសម្ព័ន្ធក្រុមហ៊ុន ច្បាប់អនុម័ត ភាសា និងទម្រង់ឯកសារ កំណត់តែម្តងក្នុងផ្នែករដ្ឋបាល ហើយនាយកដ្ឋាននីមួយៗទទួលយកទាំងនោះ។ ដូច្នេះហើយ ទើបគ្រឿងគិតលុយគ្លីនិក ស្លឹកប្រាក់ខែ និងបញ្ជីប្រតិបត្តិការគណនេយ្យ អាចស្ថិតក្នុងប្រព័ន្ធតែមួយ — ហើយការបើកសាខាថ្មីមិនមែនជាគម្រោងថ្មីទេ។',
    platformLink: 'ព័ត៌មាន Platform',
    adminGuide: 'មគ្គុទ្ទេសក៍ Admin',
    items: [
      {
        title: 'កំណត់ច្បាប់ដោយខ្លួនឯង',
        body: 'រៀបចំផ្លូវអនុម័តសម្រាប់ការឈប់សម្រាក សម្រង់តម្លៃ វិក្កយបត្រ និងស្តុក។ ផ្លាស់ប្តូរតាមអាជីវកម្មផ្លាស់ប្តូរ — មិនចាំបាច់រង់ចាំអ្នកផ្គត់ផ្គង់ ក៏មិនចាំបាច់សាងសង់ថ្មីទេ។',
      },
      {
        title: 'ជឿជាក់លើអ្នកដែលឃើញអ្វី',
        body: 'តួនាទីនីមួយៗមានម៉ឺនុយផ្ទាល់ខ្លួន ហើយជំហានរសើបដូចជាការគណនាប្រាក់ខែ មានការការពារការចូលបន្ថែម។',
      },
      {
        title: 'គ្រប់គ្នាធ្វើការជាភាសារបស់ខ្លួន',
        body: 'ខ្មែរ និងអង់គ្លេសពេញទាំងប្រព័ន្ធ — អេក្រង់ ឯកសារ ស្លឹកប្រាក់ខែ។ បន្ថែមភាសាថ្មីនៅពេលអ្នកត្រូវការ។',
      },
      {
        title: 'ធ្វើឱ្យប្រព័ន្ធសមនឹងអ្នក',
        body: 'បន្ថែមវាល និងរៀបចំអេក្រង់ឡើងវិញ តាមតម្រូវការវិស័យរបស់អ្នក ដោយចង្អុលហើយចុចតែប៉ុណ្ណោះ។',
      },
      {
        title: 'រចនាសម្ព័ន្ធក្រុមហ៊ុនតែមួយ',
        body: 'សាខា នាយកដ្ឋាន ឃ្លាំង រូបិយប័ណ្ណ និងប្រតិទិនហិរញ្ញវត្ថុ កំណត់តែម្តង — ម៉ូឌុលទាំងអស់ធ្វើតាម។',
      },
      {
        title: 'សួរចម្លើយ ជំនួសការរង់ចាំរបាយការណ៍',
        body: 'ជំនួយការ AI ដែលឆ្លើយសំណួរអំពីទិន្នន័យអាជីវកម្មរបស់អ្នក — ប្រើសេវា AI ដែលអ្នកជ្រើសរើស ឬដំណើរការនៅក្នុងស្រុក។',
      },
      {
        title: 'ការទូទាត់ និងប្រាក់ខែក្នុងស្រុក',
        body: 'វិក្កយបត្រស្កេនបង់ KHQR ពន្ធលើប្រាក់ខែ NSSF និងរបាយការណ៍អាយុការ ជាផ្នែកនៃផលិតផល — មិនមែនជា Excel បន្ថែមទេ។',
      },
      {
        title: 'រួចរាល់សម្រាប់អ្នកដែលមកត្រួតពិនិត្យ',
        body: 'លេខរៀងឯកសារដោយស្វ័យប្រវត្តិ និងប្រវត្តិផ្លាស់ប្តូរលើទិន្នន័យរសើប — អ្នកសវនកម្មអាចពិនិត្យហើយយល់ព្រមភ្លាមៗ។',
      },
    ],
  },
  features: {
    badge: 'ហេតុអ្វីជ្រើស AKAS',
    title: 'សង់ជា ERP ពិតប្រាកដ មិនមែនជាកម្មវិធីដាច់ៗជាច្រើនទេ',
    description:
      'វាលកែតម្រូវបាន ការបកប្រែ និងលំហូរការងារ អាចឆ្លើយតបសំណើ «យើងធ្វើការបែបផ្សេង» ភាគច្រើន។ មើលវីដេអូបង្ហាញ រួចអានមគ្គុទ្ទេសក៍ម៉ូឌុលនៅ docs.akas.co។',
    items: [
      {
        title: 'ថ្ងៃបើកប្រាក់ខែ ដែលអ្នកមិនចាំបាច់ព្រួយ',
        description:
          'ពន្ធលើប្រាក់ខែ NSSF អាយុការ និងរបាយការណ៍ផ្ទេរប្រាក់តាមធនាគារ ចេញពីដំណើរការគណនាប្រាក់ខែរួចស្រេច — ក្រុមហិរញ្ញវត្ថុគ្រាន់តែត្រួតពិនិត្យ ជំនួសការរៀបចំឡើងវិញ ហើយបុគ្គលិកទទួលស្លឹកប្រាក់ខែជាភាសាអង់គ្លេស ឬខ្មែរលើទូរស័ព្ទរបស់ពួកគេ។',
      },
      {
        title: 'ការសម្រេចចិត្តមិនជាប់គាំងលើតុ',
        description:
          'សំណើឈប់សម្រាក ការទិញ សម្រង់តម្លៃ និងសំណើស្តុក បញ្ជូនទៅអ្នកអនុម័តត្រឹមត្រូវដោយស្វ័យប្រវត្តិ។ បុគ្គលិកដាក់សំណើដោយខ្លួនឯងជំនួសក្រដាស ហើយអ្នកគ្រប់គ្រងអនុម័តពីទូរស័ព្ទ — ដោយមានកំណត់ត្រានៅខាងក្រោយការយល់ព្រមនីមួយៗ។',
      },
      {
        title: 'សំណុំលេខជឿបានតែមួយ',
        description:
          'អតិថិជន ទំនិញ ឬអ្នកផ្គត់ផ្គង់ បញ្ចូលតែម្តង ហើយផ្នែកលក់ ស្តុក ការលក់តាមបញ្ជរ និងគណនេយ្យប្រើដូចគ្នា។ ការទូទាត់មកដល់លឿនជាមួយវិក្កយបត្រដែលអាចបង់បាន ហើយស្តុកឈប់ស្ថិតលើ Excel ទៀត។',
      },
      {
        title: 'គ្រប់គ្រងដោយមិនចាំបាច់តាមដានគ្រប់ជំហាន',
        description:
          'តួនាទីនីមួយៗឃើញតែផ្នែករបស់ខ្លួន។ ការផ្លាស់ប្តូររសើបត្រូវកត់ត្រា ឯកសារធ្វើតាមលេខរៀងរបស់អ្នក ហើយដៃអនុម័តមិនដែលជាដៃចុះបញ្ជីនោះទេ។',
      },
    ],
    videos: [
      {
        title: 'ប្រព័ន្ធកែតម្រូវបាន',
        description: 'ការបង្ហាញពីការកំណត់ទម្រង់ និងការកែតម្រូវ',
      },
      {
        title: 'លំហូរការងារអនុម័ត',
        description: 'រចនាលំហូរការងារអនុម័តក្នុង AKAS។',
      },
    ],
    detailLink: 'មើលថា AKAS ធ្វើអ្វីសម្រាប់អាជីវកម្មអ្នក →',
    detailNote:
      'ការគណនាប្រាក់ខែដែលរៀបចំរបាយការណ៍ដោយខ្លួនឯង វិក្កយបត្រដែលអតិថិជនបង់លឿនជាង ស្តុកដែលអ្នកជឿជាក់បាន និងការអនុម័តដែលដើរទៅមុខ។',
  },
  testimonials: {
    badge: 'មតិអតិថិជន',
    title: 'អ្វីដែលអតិថិជនរបស់យើងនិយាយ',
    items: [
      {
        content:
          'AKAS បានផ្លាស់ប្តូររបៀបដែលយើងគ្រប់គ្រងប្រតិបត្តិការអាជីវកម្ម ជាមួយម៉ូឌុល Cloud ពេញលេញរបស់វា ដោយរៀបចំអ្វីៗទាំងអស់ពីការគ្រប់គ្រងទំនាក់ទំនងអតិថិជនដល់គណនេយ្យយ៉ាងរលូន។',
        author: 'Chan Sombath',
        position: 'CEO, OWP',
      },
      {
        content:
          'AKAS បានធ្វើឱ្យប្រតិបត្តិការរបស់យើងប្រសើរឡើង ជាមួយប្រព័ន្ធធនធានមនុស្ស លើ Cloud ពេញលេញ ដោយធ្វើឱ្យដំណើរការធនធានមនុស្ស របស់យើងងាយស្រួលជាងមុន ហើយបង្កើនប្រសិទ្ធភាពយ៉ាងច្រើន។',
        author: 'Hour Chansokun',
        position: 'នាយករដ្ឋបាល, iDE Cambodia',
      },
      {
        content:
          'AKAS បានផ្លាស់ប្តូរប្រតិបត្តិការធនធានមនុស្ស របស់យើង តាមរយៈប្រព័ន្ធធនធានមនុស្ស លើ Cloud ទាំងមូល ដោយធ្វើឱ្យលំហូរការងារធនធានមនុស្ស សាមញ្ញជាងមុន ហើយបង្កើនផលិតភាពរបស់យើងយ៉ាងច្រើន។',
        author: 'Tham Thavy',
        position: 'ប្រធានធនធានមនុស្ស, ICF Cambodia',
      },
    ],
  },
  notFound: {
    title: 'រកមិនឃើញទំព័រ | AKAS',
    description: 'ទំព័រដែលអ្នកស្នើសុំមិនអាចរកឃើញនៅលើ AKAS។',
    heading: 'ទំព័រនេះមិនអាចប្រើបានទេ',
    body: 'តំណអាចខូច ឬទំព័រអាចត្រូវបានដកចេញ។',
    backHome: 'ត្រឡប់ទៅទំព័រដើម',
  },
};

export default km;
